import type { StatusMarker } from "../types";

export interface StatusMarkerDefinition {
  id: StatusMarker;
  label: string;
  color: string;
}

export const STATUS_MARKERS: readonly StatusMarkerDefinition[] = [
  { id: "injured", label: "Injured", color: "#e35b4f" },
  { id: "poisoned", label: "Poisoned", color: "#78b84f" },
  { id: "prone", label: "Prone", color: "#d99b3f" },
  { id: "hidden", label: "Hidden", color: "#7c72bc" },
  { id: "concentrating", label: "Concentrating", color: "#4aaed0" },
];

export const STATUS_MARKER_BY_ID = Object.fromEntries(
  STATUS_MARKERS.map((marker) => [marker.id, marker]),
) as Record<StatusMarker, StatusMarkerDefinition>;
